/**
 * IconManager is registered in commonDependencies.ts
 */
/**
 * default icon manager. Uses material icons outlined.
 * you could use DIContainer to register an alternative IconManager for a different provider like font awesome or a different Material icon set.
 */
export class IconManager {
    constructor() {
        // map commonly used icon aliases that we might have stored in our database from previous versions / user preferences
        this.aliasMap = {
            checkbox: 'check_box',
            checkbox_empty: 'check_box_outline_blank',
            clock: 'schedule',
            collapsed: 'chevron_right',
            comment: 'comment',
            copy: 'content_copy',
            download: 'file_download',
            edit: 'edit',
            expanded: 'expand_more',
            locked: 'lock',
            ping: 'thunderstorm',
            process: 'settings_b_roll',
            refresh: 'autorenew',
            sort_asc: 'arrow_upward_alt',
            sort_desc: 'arrow_downward_alt',
            truck: 'local_shipping',
            zoom: 'search',
            'tb-icon-accountspayable-before': 'payments',
            'tb-icon-accountsreceivable-before': 'sell',
            'tb-icon-activities-before': 'local_activity',
            'tb-icon-budget-before': 'savings',
            'tb-icon-calendar-before': 'calendar_month',
            'tb-icon-company-before': 'business',
            'tb-icon-console-before': 'waterfall_chart',
            'tb-icon-contact-before': 'person',
            'tb-icon-dashboard-before': 'analytics',
            'tb-icon-dispatchq-before': 'groups',
            'tb-icon-documents-before': 'folder_open',
            'tb-icon-emailq-before': 'inbox',
            'tb-icon-expenses-before': 'receipt',
            'tb-icon-funnel-before': 'filter_alt',
            'tb-icon-helpdesk-before': 'support_agent',
            'tb-icon-invoices-before': 'receipt_long',
            'tb-icon-knowledgebase-before': 'psychology_alt',
            'tb-icon-opportunites-before': 'shopping_cart',
            'tb-icon-orders-before': 'point_of_sale',
            'tb-icon-posttimebill-before': 'punch_clock',
            'tb-icon-products-before': 'category',
            'tb-icon-project-before': 'group_work',
            'tb-icon-purchaseorders-before': 'shopping_bag',
            'tb-icon-quicklaunch-before': 'rocket_launch',
            'tb-icon-quit-before': 'cancel',
            'tb-icon-quotes-before': 'request_quote',
            'tb-icon-resourceconsole-before': 'view_timeline',
            'tb-icon-salesq-before': 'shopping_basket',
            'tb-icon-site-before': 'storefront',
            'tb-icon-subtask-before': 'task',
            'tb-icon-task-before': 'task',
            'tb-icon-template-before': 'file_copy',
            'tb-icon-timebill-before': 'schedule',
            'tb-icon-todo-before': 'checklist',
            'tb-icon-vouchers-before': 'shop',
            'tb-icon-workflow-before': 'account_tree'
        };
    }
    /**
     * Shortcut function for getting the string <i> tag produced from getIconElement.
     * Useful for adding icons in component templates
     * @param iconName
     * the name of which icon to use from the material icon set.
     * @param attributes
     * Any additional attributes to be applied to the <i> element
     */
    getIconString(iconName, attributes) {
        return this.getIconElement(iconName, attributes).outerHTML;
    }
    /**
     * Creates and returns the HTMLElement representation of the <i> tag.
     * @param iconName
     * the name of which icon to use from the material icon set.
     * @param attributes
     * Any additional attributes to be applied to the <i> element
     */
    getIconElement(iconName, attributes) {
        const iconElement = document.createElement('i');
        iconName = this.convertAlias(iconName);
        // set any attributes passed
        if (attributes) {
            for (const [key, value] of Object.entries(attributes)) {
                iconElement.setAttribute(key, value);
            }
        }
        //iconElement.classList.toggle('material-icons-outlined', true);
        iconElement.classList.toggle('material-symbols-outlined', true);
        iconElement.innerText = iconName;
        return iconElement;
    }
    updateIcon(iconElement, iconName, attributes) {
        iconName = this.convertAlias(iconName);
        if (attributes) {
            for (const [key, value] of Object.entries(attributes)) {
                iconElement.setAttribute(key, value);
            }
        }
        iconElement.classList.toggle('empty', !iconName);
        if (iconName === '&nbsp;') {
            iconElement.innerHTML = iconName;
        }
        else {
            iconElement.innerText = iconName;
        }
        return iconElement;
    }
    convertAlias(alias) {
        if (this.aliasMap[alias]) {
            return this.aliasMap[alias];
        }
        return alias;
    }
}
